<template>
    <div v-if="visible" class="batch-settings-modal-overlay" @click="closeModal">
        <div class="batch-settings-modal" @click.stop>
            <div class="modal-header">
                <h3>批量设置</h3>
                <button class="close-btn" @click="closeModal">
                    <i class="el-icon-close"></i>
                </button>
            </div>
            <div class="modal-content">
                <div class="batch-info">
                    <div class="info-item">
                        <span class="label">选中用户：</span>
                        <span class="value">{{ selectedUserIds.length }} 个</span>
                    </div>
                    <div class="info-item">
                        <span class="label">设置类型：</span>
                        <div class="type-selector">
                            <label class="type-checkbox">
                                <input type="checkbox" v-model="selectedTypes" value="message" />
                                <span class="checkbox-label">消息</span>
                            </label>
                            <label class="type-checkbox">
                                <input type="checkbox" v-model="selectedTypes" value="email" />
                                <span class="checkbox-label">邮件</span>
                            </label>
                        </div>
                    </div>
                </div>

                <div class="settings-form">
                    <div class="form-section">
                        <h4 class="section-title">
                            <i class="el-icon-setting"></i>
                            发送参数设置
                        </h4>



                        <div class="form-group">
                            <label class="form-label">未互动时间</label>
                            <div class="interval-input">
                                <input v-model.number="unSendUserTime" type="number" class="form-input" min="1"
                                    placeholder="请输入未互动时间" />
                                <span class="unit-text">小时</span>
                            </div>
                        </div>

                        <div class="form-group">
                            <label class="form-label">持续时间</label>
                            <div class="interval-input">
                                <input v-model.number="intervalTime" type="number" class="form-input" min="1"
                                    placeholder="请输入持续时间" />
                                <span class="unit-text">小时</span>
                            </div>
                        </div>

                        <div class="form-group">
                            <label class="form-label">每次发送给多少用户</label>
                            <div class="number-input">
                                <input v-model.number="sendUserNum" type="number" class="form-input" min="1" max="100"
                                    placeholder="请输入每次发送给多少用户" />
                                <div class="number-controls">
                                    <button type="button" class="number-btn"
                                        @click="adjustNumber('sendUserNum', 1)">+</button>
                                    <button type="button" class="number-btn"
                                        @click="adjustNumber('sendUserNum', -1)">-</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <p style="color: red;">*持续时间>未互动时间时，同一客户可能会收到多次相同的消息</p>
                </div>

                <div class="modal-actions">
                    <button class="cancel-btn" @click="closeModal">取消</button>
                    <button class="confirm-btn" @click="handleSubmit" :disabled="isSubmitting">
                        <svg v-if="!isSubmitting" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                        </svg>
                        <svg v-if="isSubmitting" class="loading-spinner" width="16" height="16" viewBox="0 0 24 24"
                            fill="currentColor">
                            <path d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z">
                                <animateTransform attributeName="transform" attributeType="XML" type="rotate" dur="1s"
                                    from="0 12 12" to="360 12 12" repeatCount="indefinite" />
                            </path>
                        </svg>
                        <span>{{ isSubmitting ? '设置中...' : '确认设置' }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { batchAddMassTask, pdMassMessageMassTask } from '@/api/talkytimes/masSending'

export default {
    name: 'BatchSettingsModal',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        selectedUserIds: {
            type: Array,
            default: () => []
        },
        activeTab: {
            type: String,
            default: 'message'
        }
    },
    data() {
        return {
            selectedTypes: ['message', 'email'], // 默认选中消息和邮件
            intervalTime: '',
            sendUserNum: '',
            unSendUserTime: '',
            isSubmitting: false
        }
    },
    methods: {
        closeModal() {
            this.$emit('close');
            this.resetForm();
        },

        resetForm() {
            this.selectedTypes = ['message', 'email'];
            this.intervalTime = 1; // 默认1小时
            this.sendUserNum = 20;
            this.unSendUserTime = 4;
            this.isSubmitting = false;
        },

        adjustNumber(field, delta) {
            const currentValue = this[field];
            const newValue = currentValue + delta;

            if (field === 'sendUserNum') {
                if (newValue >= 1 && newValue <= 100) {
                    this[field] = newValue;
                }
            }
        },

        async handleSubmit() {
            if (this.selectedTypes.length === 0) {
                this.$message.warning('请至少选择一种类型');
                return;
            }

            if (this.intervalTime < 1) {
                this.$message.warning('请输入有效的间隔时间');
                return;
            }

            if (this.sendUserNum < 1 || this.sendUserNum > 100) {
                this.$message.warning('发送人数应在1-100之间');
                return;
            }

            if (this.unSendUserTime < 1) {
                this.$message.warning('请输入有效的未聊天时间');
                return;
            }

            this.isSubmitting = true;

            try {
                // 使用 pdMassMessageMassTask 接口进行批量设置
                // 根据选择的类型确定 jobType
                let jobType;
                if (this.selectedTypes.length === 2) {
                    jobType = 2; // 同时设置消息和邮件
                } else if (this.selectedTypes.includes('message')) {
                    jobType = 1; // 只设置消息
                } else {
                    jobType = 0; // 只设置邮件
                }

                const massTaskData = {
                    idUsers: this.selectedUserIds,
                    jobType: jobType, // 0:邮件 1:消息 2:邮件+消息
                    sendUserNum: this.sendUserNum,
                    intervalTime: this.intervalTime * 60, // 转换为分钟
                    unSendUserTime: this.unSendUserTime
                };

                console.log('批量设置数据:', massTaskData);
                await pdMassMessageMassTask(massTaskData);

                const typeText = this.selectedTypes.length === 2 ? '消息和邮件' :
                    this.selectedTypes.includes('message') ? '消息' : '邮件';
                this.$emit('success', `已成功为 ${this.selectedUserIds.length} 个用户设置${typeText}发送参数`);
                this.closeModal();
            } catch (error) {
                console.error('批量设置失败:', error);
                this.$emit('error', '批量设置失败，请重试');
            } finally {
                this.isSubmitting = false;
            }
        }
    }
}
</script>

<style scoped>
.batch-settings-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    backdrop-filter: blur(5px);
}

.batch-settings-modal {
    background: white;
    border-radius: 12px;
    width: 90%;
    max-width: 800px;
    max-height: 90vh;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
    animation: modalSlideIn 0.3s ease-out;
}

@keyframes modalSlideIn {
    from {
        opacity: 0;
        transform: translateY(-50px) scale(0.9);
    }

    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 24px;
    border-bottom: 1px solid rgba(229, 231, 235, 0.8);
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
}

.modal-header h3 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #1f2937;
}

.close-btn {
    width: 32px;
    height: 32px;
    border: none;
    background: rgba(239, 68, 68, 0.1);
    color: #ef4444;
    border-radius: 6px;
    font-size: 18px;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
}

.close-btn:hover {
    background: rgba(239, 68, 68, 0.2);
    transform: scale(1.1);
}

.modal-content {
    padding: 24px;
    max-height: calc(90vh - 80px);
    overflow-y: auto;
}

.batch-info {
    display: flex;
    gap: 24px;
    margin-bottom: 24px;
    padding: 16px;
    background: rgba(139, 92, 246, 0.05);
    border-radius: 8px;
    border: 1px solid rgba(139, 92, 246, 0.1);
}

.info-item {
    display: flex;
    align-items: center;
    gap: 8px;
}

.info-item .label {
    font-size: 14px;
    color: #6b7280;
    font-weight: 500;
}

.info-item .value {
    font-size: 14px;
    color: #1f2937;
    font-weight: 600;
}

.type-selector {
    display: flex;
    gap: 16px;
}

.type-checkbox {
    display: flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    padding: 4px 8px;
    border-radius: 6px;
    transition: all 0.3s ease;
}

.type-checkbox:hover {
    background: rgba(139, 92, 246, 0.1);
}

.type-checkbox input[type="checkbox"] {
    width: 16px;
    height: 16px;
    accent-color: #8b5cf6;
    cursor: pointer;
}

.checkbox-label {
    font-size: 14px;
    color: #374151;
    font-weight: 500;
    cursor: pointer;
}

.settings-form {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.form-section {
    border: 1px solid rgba(229, 231, 235, 0.8);
    border-radius: 8px;
    padding: 20px;
    background: rgba(248, 250, 252, 0.5);
}

.section-title {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 0 0 16px 0;
    font-size: 16px;
    font-weight: 600;
    color: #1f2937;
    padding-bottom: 8px;
    border-bottom: 2px solid rgba(139, 92, 246, 0.2);
}

.section-title i {
    color: #8b5cf6;
    font-size: 18px;
}

.form-group {
    margin-bottom: 16px;
}

.form-group:last-child {
    margin-bottom: 0;
}

.form-label {
    display: block;
    margin-bottom: 8px;
    font-size: 14px;
    font-weight: 600;
    color: #374151;
}

.form-input {
    width: 100%;
    padding: 12px 16px;
    border: 1px solid rgba(229, 231, 235, 0.8);
    border-radius: 8px;
    font-size: 14px;
    color: #1f2937;
    background: white;
    transition: all 0.3s ease;
}

.form-input:focus {
    outline: none;
    border-color: #8b5cf6;
    box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.1);
}

.form-textarea {
    width: 100%;
    padding: 12px 16px;
    border: 1px solid rgba(229, 231, 235, 0.8);
    border-radius: 8px;
    font-size: 14px;
    color: #1f2937;
    background: white;
    resize: vertical;
    min-height: 100px;
    font-family: inherit;
    transition: all 0.3s ease;
}

.form-textarea:focus {
    outline: none;
    border-color: #8b5cf6;
    box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.1);
}

.interval-input {
    display: flex;
    align-items: center;
    gap: 8px;
}

.interval-input .form-input {
    flex: 1;
}

.unit-text {
    font-size: 14px;
    color: #6b7280;
    font-weight: 500;
    white-space: nowrap;
}

.number-input {
    display: flex;
    align-items: center;
    gap: 8px;
}

.number-input .form-input {
    flex: 1;
}

.number-controls {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.number-btn {
    width: 32px;
    height: 24px;
    border: 1px solid rgba(139, 92, 246, 0.3);
    background: rgba(139, 92, 246, 0.1);
    color: #8b5cf6;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
}

.number-btn:hover {
    background: rgba(139, 92, 246, 0.2);
    border-color: #8b5cf6;
}

.number-btn:active {
    transform: scale(0.95);
}



.modal-actions {
    display: flex;
    gap: 16px;
    justify-content: flex-end;
    margin-top: 24px;
    padding-top: 20px;
    border-top: 1px solid rgba(229, 231, 235, 0.8);
}

.cancel-btn,
.confirm-btn {
    padding: 12px 24px;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    min-width: 100px;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    justify-content: center;
}

.cancel-btn {
    background: rgba(107, 114, 128, 0.1);
    color: #6b7280;
}

.cancel-btn:hover {
    background: rgba(107, 114, 128, 0.2);
    transform: translateY(-1px);
}

.confirm-btn {
    background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
    color: white;
    box-shadow: 0 4px 15px rgba(139, 92, 246, 0.3);
}

.confirm-btn:hover:not(:disabled) {
    background: linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%);
    box-shadow: 0 6px 20px rgba(139, 92, 246, 0.4);
    transform: translateY(-1px);
}

.confirm-btn:disabled {
    background: linear-gradient(135deg, #a78bfa 0%, #8b5cf6 100%);
    opacity: 0.8;
    cursor: not-allowed;
    transform: none;
    box-shadow: 0 4px 15px rgba(139, 92, 246, 0.2);
}

.confirm-btn:disabled:hover {
    transform: none;
    box-shadow: 0 4px 15px rgba(139, 92, 246, 0.2);
}

.loading-spinner {
    animation: spin 1s linear infinite;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}
</style>
